export default "__VITE_ASSET__DN4j_r_$__"